import { DOCUMENT } from '@angular/common'
import { Inject, Injectable } from '@angular/core'
import type { TeyaBlocks, TeyaBlocksOptions } from '@teyaproduct/teya-blocks-js'
import { environment } from '../../../environments/environment'

export type TeyaConstructor = new (token: string, options?: TeyaBlocksOptions) => TeyaBlocks

@Injectable({ providedIn: 'root' })
export class TeyaClientLoader {
    private constructorPromise: Promise<TeyaConstructor> | null = null

    constructor(@Inject(DOCUMENT) private readonly document: Document) {}

    load(): Promise<TeyaConstructor> {
        if (this.constructorPromise) {
            return this.constructorPromise
        }
        this.constructorPromise = new Promise<TeyaConstructor>((resolve, reject) => {
            const view = this.document.defaultView
            if (!view) {
                reject(new Error('Teya requires a browser'))
                return
            }
            if (view.TeyaBlocks) {
                resolve(view.TeyaBlocks)
                return
            }
            const script = this.document.createElement('script')
            script.src = environment.production
                ? 'https://cdn.teya.com/static/web-sdk/js/teya.js'
                : 'https://cdn.teya.xyz/static/web-sdk/js/teya.js'
            script.async = true
            const timeout = setTimeout(() => fail(), 30000)
            const fail = () => {
                clearTimeout(timeout)
                script.remove()
                reject(new Error('Unable to load the secure payment form. Please try again.'))
            }
            script.onload = () => {
                clearTimeout(timeout)
                if (view.TeyaBlocks) {
                    resolve(view.TeyaBlocks)
                } else {
                    fail()
                }
            }
            script.onerror = fail
            this.document.head.appendChild(script)
        }).catch(error => {
            this.constructorPromise = null
            throw error
        })
        return this.constructorPromise
    }
}
